__turbopack_context__.v({
  "bottom": "kMWajq_bottom",
  "filters": "kMWajq_filters",
  "form": "kMWajq_form",
  "job": "kMWajq_job",
  "location": "kMWajq_location",
  "typeaheads": "kMWajq_typeaheads",
});
